import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountProviderUser, TAccountProviderUserPayloadRequest, TAccountProviderUserResponse, adaptAccountProviderUserFromResponse, adaptAccountProviderUserToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PROVIDER_USER } from '../../backend-paths';


export const accountProviderUserCreateApi = createAsyncThunk(
	`POST/${BACKEND_ACCOUNT_PROVIDER_USER}`,
	(payload: TAccountProviderUserPayloadRequest, thunkApi) => {
		const dataRequest = adaptAccountProviderUserToRequest(payload);

		return HttpService.post<TAccountProviderUserResponse>(BACKEND_ACCOUNT_PROVIDER_USER, dataRequest).then(result => {
			return adaptAccountProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProviderUserCreateSlice = createSlice({
	name: 'accountProviderUserCreateSlice',
	initialState,
	reducers: {
		clearAccountProviderUserCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProviderUserCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[accountProviderUserCreateApi.fulfilled.type]: (state, action: PayloadAction<TAccountProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProviderUserCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useAccountProviderUserCreateSelector = () => useAppSelector(state => state[accountProviderUserCreateSlice.name]);

export const { clearAccountProviderUserCreate } = accountProviderUserCreateSlice.actions;
